<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex align-items-center justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button pButton pRipple routerLink="profiles/new" label=" {{'common.new' | transloco}}" icon="pi pi-plus"
                class="md:mr-2 p-button-primary mb-2 md:mb-0"></button>
            </div>
            <div class="flex flex-column md:flex-row justify-content-end">
              <button pButton label=" {{'common.filters' | transloco}}" class="p-button-secondary"
                icon="pi pi-sliders-h" (click)="filtersVisible = !filtersVisible"></button>
            </div>
          </div>
        </div>
        <p-table (onLazyLoad)="onPageChange($event)" [(first)]="first" [(rows)]="rows" [lazy]="true" [paginator]="true"
          [responsive]="true" [rowsPerPageOptions]="[10,25,50]" [totalRecords]="totalProfiles" [value]="profiles"
          styleClass="p-datatable-striped" dataKey="profileUuid">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" style="width: 3rem"></th>
              <th scope="col">
                {{'attribute.name' | transloco}}</th>
              <th scope="col">
                {{'attribute.description' | transloco}}</th>
              <th scope="col">
                {{'attribute.creationDate' | transloco}}</th>
              <th scope="col">
                {{'attribute.numberOfPermissions' | transloco}}</th>
              <th scope="col" style="width: 10rem;"></th>
            </tr>
          </ng-template>
          <ng-template let-profile pTemplate="body" let-expanded="expanded">
            <tr *ngIf="!loadingProfiles && profile">
              <td>
                <button type="button" pButton pRipple [pRowToggler]="profile"
                  class="p-button-text p-button-rounded p-button-plain"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
              </td>
              <td>{{profile.name}}</td>
              <td>{{profile.description}}</td>
              <td>{{profile.creationDate | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}</td>
              <td>{{profile.permissions.length | number: '' : this.language}}</td>
              <td>
                <div class="flex justify-content-end">
                  <button [routerLink]="'profiles/' + profile.profileUuid + '/edit'"
                    class="p-button-rounded btn-primary-light mr-2" icon="pi pi-pencil" pButton pRipple></button>
                  <button (click)="confirmAndDelete(profile)" class="p-button-rounded btn-danger-light"
                    icon="pi pi-trash" pButton pRipple [disabled]="profile.predefined"></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingProfiles">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-profile>
            <tr>
              <td colspan="6">
                <div class="p-p-3">
                  <div *ngIf="profile.permissions && profile.permissions.length > 0">
                    <p class="font-semibold mt-1">{{'model.permissions' | transloco}}:</p>
                    <div class="flex flex-wrap align-items-center my-3">
                      <p-chip *ngFor="let permission of profile.permissions" label="{{permission.name}}"
                        styleClass="m-1 custom-chip"></p-chip>
                    </div>
                  </div>
                  <div *ngIf="!profile.permissions || profile.permissions.length == 0"
                    class="flex align-items-center m-3">
                    <p class="font-medium">{{'empty.permissions' | transloco}}</p>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="totalProfiles == 0" class="flex align-items-center justify-content-between">{{'pagination.empty'
              | transloco}}</div>
            <div *ngIf="totalProfiles > 0" class="flex align-items-center justify-content-between">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalProfiles ? totalProfiles : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalProfiles}}
              {{(totalProfiles > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters()" [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible" appAutoFocus class="w-full" id="name" pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="range">{{'attribute.creationDate' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-calendar [(ngModel)]="rangeDates" [showIcon]="true" [showButtonBar]="true" [monthNavigator]="true"
          [yearNavigator]="true" [yearRange]="availableYearRange" [firstDayOfWeek]="1" styleClass="w-full"
          appendTo="body" selectionMode="range" dateFormat="dd/mm/yy" [placeholder]="'select.dateRange' | transloco" id="range" inputId="range"></p-calendar>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="permission">{{'model.permission' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input (keyup.enter)="filtersVisible = false; applyFilters()" [(ngModel)]="currentFilters.permission"
          class="w-full" id="permission" pInputText type="text">
      </div>
    </div>
    <div class="col-12">
      <p-button (onClick)="filtersVisible = false; applyFilters()" [disabled]="!(
                  currentFilters.name ||
                  rangeDates ||
                  (currentFilters.from &&
                  currentFilters.until) ||
                  currentFilters.permission
                )" label="{{'common.filter' | transloco}}" styleClass="p-button-primary mx-2 mt-2" type="button">
      </p-button>
      <p-button (click)="resetFilters(); filtersVisible = false; applyFilters()" label="{{'common.clear' | transloco}}"
        styleClass="p-button-danger" type="button"></p-button>
    </div>
  </div>
</p-sidebar>

<app-delete-profile-dialog *ngIf="showCustomDialog"
              [visible]="showCustomDialog"
              [profiles]="profileOptions"
              [profile]="selectedProfile"
              (onClose)="onClose($event)">
</app-delete-profile-dialog>
